var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table-expanded',{attrs:{"colspan":_vm.$attrs['headers'].length}},[_c('v-row',[_c('v-col',[_c('table',[_c('tr',[_c('td',[_vm._v("Содержание:")]),_c('td',[_vm._v(_vm._s(_vm.Task.Content))])])])]),_c('v-col',[_c('table',[_c('tr',[_c('td',[_c('div',[_vm._v("Результат:")])]),_c('td',[_c('div',[_vm._v(_vm._s(_vm.Task.Result))])])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }